export const SpiderMark = ({ size = 36 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill="#09090B" stroke="#E60026" strokeWidth="2" />
        <g stroke="#E60026" strokeWidth="1.6" opacity="0.85" strokeLinecap="round">
            <line x1="32" y1="8" x2="32" y2="56" />
            <line x1="10" y1="24" x2="54" y2="40" />
            <line x1="54" y1="24" x2="10" y2="40" />
        </g>
        <g stroke="#FF1E27" strokeWidth="2.6" strokeLinecap="round">
            <path d="M26 32 L15 24 L12 14" />
            <path d="M38 32 L49 24 L52 14" />
            <path d="M26 38 L14 42 L10 52" />
            <path d="M38 38 L50 42 L54 52" />
        </g>
        <ellipse cx="32" cy="38" rx="7" ry="9" fill="#E60026" />
        <circle cx="32" cy="26" r="4.5" fill="#FF1E27" />
    </svg>
);

export default function SpideyLogo({ size = 36 }) {
    return (
        <span className="flex items-center gap-2.5 select-none" data-testid="spidey-logo-link">
            <SpiderMark size={size} />
            <span className="font-display text-xl tracking-wide text-white leading-none">
                DRIP4<span className="text-spidey-red">SAISONS</span>
            </span>
        </span>
    );
}
